import { useMutation } from "react-query";
import { POST } from "../../../../Services";

export const useEditarImagen = () => {
  return useMutation(async (data) => {
    data.idPokemon = data.id;
    delete data.id;
    const response = await POST(data, "pokemon/editarImagenesPokemon");
    return response.data;
  });
};
